.container {
  height: 100%;
  width: 100%;
  padding: 0.5rem;
}
